var map = {
	"./en/1-3/reward_bg.png": 62101,
	"./fi/1-3/reward_bg.png": 82415,
	"./in/1-3/reward_bg.png": 86585,
	"./th/1-3/reward_bg.png": 63016,
	"./tw/1-3/reward_bg.png": 99835,
	"./zh/1-3/reward_bg.png": 66298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48549;